import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { SegundaViaService } from '../services/segundavia.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Contrato } from '../modelo/contrato';
import { Cliente } from '../modelo/cliente';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MatDialog } from '@angular/material';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';

declare var $: any;

@Component({
  selector: 'app-segundaviacarne-selecao',
  templateUrl: './segundaviacarne-selecao.component.html',
  styleUrls: ['./segundaviacarne.component.css'],
  providers: [SegundaViaService, MensagemService, RestClientService]
})
export class SegundaviacarneSelecaoComponent extends AbstractComponent implements OnInit {

  cliente: Cliente = new Cliente();

  constructor(
    private sessaoService: SessaoService,
    private segundaViaService: SegundaViaService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  ngOnInit() {
    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".carne").addClass("active");

    //Scroll top
    window.scrollTo(0, 0);
    this.buscaContratos();

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  /**
   * Lista os contratos
   */
  buscaContratos = (): void => {
    this.segundaViaService.listarContrato().subscribe(
      (result: Cliente) => {
        if (result.cdMsgemRetorno === '1007') {
          this.sair();
        } else {
          this.cliente = result;
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  recuperarContrato = (contrato: Contrato, route: string): void => {
    this.segundaViaService.recuperarContrato(contrato).subscribe(
      (result: Contrato) => {
        if (result.cdMsgemRetorno == "0") {
          contrato = result;
          sessionStorage.setItem('segundaViaContrato', JSON.stringify(contrato));
          this.router.navigate(['/BF-Portal/segundaviacarneEndereco']);
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
  * Efetua o logout do sistema e redireciona para o autoline
  */
  sair() {
    sessionStorage.removeItem("sessao");
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
    this.router.navigate(['/redirecionamento']);
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundaviacarne-cli/segundaviacarne-selecao.component.ts